import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { StructuredRecordEditorCareMapDrawer } from './structured-records/StructuredRecordEditorCareMapDrawer';
import { AllergyDescriptor } from './AllergyDescriptor';
import { AllergyFormState } from './AllergyFormState';

export type IAllergyEditorCareMapDrawerProps = {
    id: string;
};

export const AllergyEditorCareMapDrawer: FC<IAllergyEditorCareMapDrawerProps> = ({ id }) => {
    const descriptor = useInstance(AllergyDescriptor);
    const formState = useInstance(AllergyFormState);

    return (
        <StructuredRecordEditorCareMapDrawer
            descriptor={descriptor}
            formState={formState}
            id={id}
        />
    );
};
